let isJest = 'undefined' != typeof jest;
let isCypress = void 0 !== globalThis.Cypress;
let isMocha =
  void 0 !== globalThis.beforeEach &&
  'function(name,fn){suites[0].beforeEach(name,fn);}' ===
    `${globalThis.beforeEach}`.replace(/\s/g, '') &&
  !isCypress;
let isVitest = void 0 !== globalThis.__vitest_index__;
let isUnitTest = isJest || isVitest || isMocha;
export { isUnitTest };
